import { TFunction } from 'i18next'
import {
  INSTALLATION_SEARCH_PATH,
  MISSING_IBN_PATH,
  NEW_INSTALLATIONS_PATH,
  NO_ACCESS_PATH,
  PLANNED_INSTALLATIONS,
  REQUIRE_ATTENTION_INSTALLATIONS_PATH,
} from '../constants'
import { InstallationTabVariant } from '../models'
import { InstallationTab } from '../types'
import { isFlowTheme } from 'src/Libs/utils'

/**
 * return installation tabs shown in the installer dashboard
 */
export const getInstallationTabs = (t: TFunction, variant: InstallationTabVariant, includePlannedInstallations = true): InstallationTab[] => {
  const smTabs = variant === 'sm'
  const mdTabs = variant === 'md'

  // This is a temporary solution until we worked on enabling this feature for flow installers as well.
  if (isFlowTheme) {
    return [
      {
        name: t('companyDashboard.search'),
        url: INSTALLATION_SEARCH_PATH,
        dataQa: 'tab-installerDashboard-search',
      },
      {
        name: mdTabs || smTabs ? t('companyDashboard.requireAttentionInstallationsMobile') : t('companyDashboard.requireAttentionInstallations'),
        url: REQUIRE_ATTENTION_INSTALLATIONS_PATH,
        dataQa: 'tab-installerDashboard-requireAttention',
      },
    ]
  }

  const tabs: InstallationTab[] = [
    {
      name: t('companyDashboard.search'),
      url: INSTALLATION_SEARCH_PATH,
      dataQa: 'tab-installerDashboard-search',
    },
    {
      name: smTabs ? t('companyDashboard.newestInstallationsMobile') : t('companyDashboard.newestInstallations'),
      url: NEW_INSTALLATIONS_PATH,
      dataQa: 'tab-installerDashboard-newInstallations',
    },
    {
      name: mdTabs || smTabs ? t('companyDashboard.requireAttentionInstallationsMobile') : t('companyDashboard.requireAttentionInstallations'),
      url: REQUIRE_ATTENTION_INSTALLATIONS_PATH,
      dataQa: 'tab-installerDashboard-requireAttention',
    },
    {
      name: t('companyDashboard.missingIbn'),
      url: MISSING_IBN_PATH,
      dataQa: 'tab-installerDashboard-missingIbn',
    },
    {
      name: t('companyDashboard.no-access'),
      url: NO_ACCESS_PATH,
      dataQa: 'tab-installer-dashboard-no-access',
    },
  ]

  if (includePlannedInstallations) {
    tabs.push({
      name: t('companyDashboard.planned-installations'),
      url: PLANNED_INSTALLATIONS,
      dataQa: 'tab-installer-dashboard-planned-installations',
    })
  }

  return tabs
}
